import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.35 6.35l-5 5a.5.5 0 01-.7 0l-5-5a.5.5 0 11.7-.7L8 10.29l4.65-4.64a.5.5 0 01.7.7z" fill="#bcd1f7" /></svg>);